import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Card from 'material-ui/Card';
import Grid from 'material-ui/Grid';
import BookTileFooter from './BookTileFooter';
import IconButton from 'material-ui/IconButton';
import CloseIcon from 'material-ui-icons/Close';
import RadioCheckedIcon from 'material-ui-icons/RadioButtonChecked';
import noCoverImgSrc from '../../assets/images/components/no_book_cover.png';

class DialogBookTile extends Component {
    static propTypes = {
        book: PropTypes.object.isRequired,
        isInWatchList: PropTypes.bool.isRequired,
        isInReadList: PropTypes.bool,
        addToWatchList: PropTypes.func,
        removeFromWatchList: PropTypes.func,
        addToReadList: PropTypes.func,
        removeFromReadList: PropTypes.func,
        closeDialogHandler: PropTypes.func
    };

    clickHandler = (type) => {
        const {
            book,
            isInWatchList,
            isInReadList,
            removeFromWatchList,
            addToWatchList,
            addToReadList,
            removeFromReadList
        } = this.props;
        switch(type) {
            case 'bookMark':
                isInWatchList ? removeFromWatchList(book) : addToWatchList(book);
                this.props.closeDialogHandler();
                break;
            case 'readMark':
                isInReadList ? removeFromReadList(book) : addToReadList(book);
                this.props.closeDialogHandler();
                break;
            default:
                break;
        }
    };

    render() {
        const {
            isInWatchList,
            isInReadList,
            closeDialogHandler
        } = this.props;

        const {
            imageSrc,
            title,
            author,
            annotations,
            series,
            genre,
            grade,
            isHighGradeBook,
        } = this.props.book
        return (
            <Grid item xs={12}>
                <Card>
                    <IconButton disableRipple
                                className="dialogBookTile__closeIcon"
                                tabIndex="0"
                                color="default"
                                onClick={ () => {closeDialogHandler()}}
                                aria-label="Close book detail dialog">
                        <CloseIcon />
                    </IconButton>
                    <div className="dialogBookTile__card--bookCover">
                        <div className="dialogBookTile__card--bookCover--image">
                            <img src={imageSrc? imageSrc : noCoverImgSrc}
                                 alt="book-cover"/>
                        </div>
                        <div className="dialogBookTile__card--bookCover--title">
                            <p className="dialogBookTile--title card--right--bookname" >
                                {isHighGradeBook === 'Y'? <span><RadioCheckedIcon></RadioCheckedIcon></span> : isHighGradeBook==='N'? '': isHighGradeBook ? <span><RadioCheckedIcon></RadioCheckedIcon></span> : ''}
                                <span className="bookname--text">{title}</span>
                                </p>
                            <p className="card--right--author">{author}</p>
                        </div>
                    </div>
                    <div className="dialogBookTile__card--book">
                        {isHighGradeBook === 'Y'? <div className="dialogBookTile__card--book--highGrade">
                            <RadioCheckedIcon />
                            <p>This title is for more mature readers and is usually read
                            by students in Year 9, 10 and above.</p></div> : isHighGradeBook ==='N'? '': isHighGradeBook ?
                            <div className="dialogBookTile__card--book--highGrade">
                            <RadioCheckedIcon />
                            <p>This title is for more mature readers and is usually read
                           by students in Year 9, 10 and above.</p></div> : ''}
                        <div className="dialogBookTile__card--book--annotations">
                            <p><span className="sr-only">Annotations:</span>{annotations}</p>
                        </div>
                        <div className="dialogBookTile__card--book--info">
                            <p><strong>Series</strong> <span>{series}</span></p>
                            <p><strong>Genre</strong> <span>{genre}</span></p>
                            <p><strong>Challenge Level</strong> <span>{grade}</span></p>
                        </div>
                    </div>
                    <div>
                        <BookTileFooter
                            clickHandler={this.clickHandler}
                            isInWatchList={isInWatchList}
                            isInReadList={isInReadList}
                            height={40}
                        />
                    </div>
                </Card>
            </Grid>
        );
    }
}

export default DialogBookTile
